var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
import { Environment } from "../Infra/Environment";
export class StudyLinkDialogViewModel {
    constructor(opts) {
        this.bannerUIManager = opts.container.bannerUIManager;
        this.authManager = opts.container.authManager;
        this.study = opts.study;
        const env = new Environment();
        this.webAppBaseUrl = env.WEBAPP_BASE_URL;
    }
    get title() {
        return `Share the patient recruitment link for ‘${this.study.title}’`;
    }
    get width() {
        return 444;
    }
    get prescreenLink() {
        if (!this.authManager.orgId)
            return "";
        return `${this.webAppBaseUrl}/#/patient-consent/${this.study.id}/prescreen/link`;
    }
    get enrollmentLink() {
        if (!this.authManager.orgId)
            return "";
        return `${this.webAppBaseUrl}/#/patient-consent/${this.study.id}/enrollment/link`;
    }
    get prescreenDownloadName() {
        return `prescreening-${this.study.id}`;
    }
    get enrollmentDownloadName() {
        return `enrollment-${this.study.id}`;
    }
    async copyLink(link) {
        await navigator.clipboard.writeText(link);
        this.bannerUIManager.displayBanner({ text: "Link copied to clipboard" });
    }
}
__decorate([
    computed
], StudyLinkDialogViewModel.prototype, "title", null);
__decorate([
    computed
], StudyLinkDialogViewModel.prototype, "width", null);
__decorate([
    computed
], StudyLinkDialogViewModel.prototype, "prescreenLink", null);
__decorate([
    computed
], StudyLinkDialogViewModel.prototype, "enrollmentLink", null);
__decorate([
    computed
], StudyLinkDialogViewModel.prototype, "prescreenDownloadName", null);
__decorate([
    computed
], StudyLinkDialogViewModel.prototype, "enrollmentDownloadName", null);
